/* eslint-disable no-alert, no-console */

import {FETCH_TEST_USERS,
	CREATE_TEST_USER,
	UPDATE_TEST_USER,
	DELETE_TEST_USER,
	SHOW_CREATE_DIALOG,
	HIDE_CREATE_DIALOG,
	UPDATE_MESSAGE
} from '../actions/testusers'

import {LOGOUT} from '../actions/auth'



const state = {
	testusers: [],
	// testuserApiUrl: "https://g0ddrithvj.execute-api.us-east-1.amazonaws.com/v1/testuser",
	// testuserApiUrl: "https://yarxh2is00.execute-api.us-east-1.amazonaws.com/v1/testuser", 
	// testuserApiUrl: "https://0waajbdhn5.execute-api.us-east-1.amazonaws.com/v1/testuser", //idmtools engineering
	testuserApiUrl: "https://ng2lprmnrc.execute-api.us-east-1.amazonaws.com/v1/testuser", //idmtools dev
	showCreateDialog: false,
	message: {
		text: "",
		variant: "danger"
	}
}

const getters = {
	testusers: state => state.testusers
}

/* eslint-disable no-alert, no-unused-vars */

const mutations = {
	[FETCH_TEST_USERS]: (state, testusers)=> {
		state.testusers = testusers
	},

	[CREATE_TEST_USER]: (state, newusers) => {
		state.testusers = [...state.testusers, ...newusers]
	},

	[UPDATE_TEST_USER]: (state, {editResult, editUid})=> {
		//const ldapChanges = updateResult?.['ldap']
		//const upsChanges = updateResult?.['ups']

		state.testusers = state.testusers.map((testuser) => {
			if (testuser.ldap.uid === editUid) {

				const updatedTestuser = {}
				Object.assign(updatedTestuser, testuser)
				Object.assign(updatedTestuser.ldap, editResult?.ldap ?? {})
				Object.assign(updatedTestuser.ups, editResult?.ups ?? {})

				return updatedTestuser
			} else {
				return testuser
			}
		})

	},

	[DELETE_TEST_USER]: (state, deletedUser) => {
		state.testusers = state.testusers.filter((user) => {
			return user.ldap.uid !== deletedUser.uid
		})
	}, 

	[SHOW_CREATE_DIALOG]: (state) => {
		state.showCreateDialog = true
	},

	[HIDE_CREATE_DIALOG]: (state) => {
		state.showCreateDialog = false
	},

	[UPDATE_MESSAGE]: (state, message) => {

		state.message.text = message
	}


}

const markSisAndUpsUsers = (users) => {
	return users.map((user) => {
		return {
			...user,
			isSis: user.ldap.umServiceStatus.includes("testuser-system:sis"),
			isUps: user.ldap.umServiceStatus.includes("testuser-system:ups")
		}
	})
}

const actions = {
	[FETCH_TEST_USERS]: ({commit, rootState, state})=> {
		const axios = require('axios')
		console.log("token:\t"  + rootState.auth.token)
		axios.defaults.headers.common['Authorization'] = rootState.auth.token

		
		return axios.get(state.testuserApiUrl)
			.then(async (result) => {
				var fetchedUsers = markSisAndUpsUsers(
					result.data.ldap.map((testuserLdap) => {
						return { ldap: testuserLdap }
					})
				)

				fetchedUsers = await Promise.all(fetchedUsers.map((testuser) => {
					if (testuser.isUps) {
						return axios.get(state.testuserApiUrl + "/" + testuser.ldap.uid + "/ups")
							.then((result) => {
								return {...testuser, ups: result.data.ups?.[0] ?? {}}
							})
							.catch((error) => {
								console.log(error)

								commit("UPDATE_MESSAGE","Unable to retrieve UPS data for some testusers!")
								return Promise.resolve(testuser)
							})
					} else {
						return testuser
					}
				})).then((result) => (result))

				commit(FETCH_TEST_USERS, fetchedUsers)
				
			})
			.catch((error) => {
				commit(LOGOUT)
				return Promise.reject(error)
			})
	},

	[CREATE_TEST_USER]: ({commit,state,rootState,rootGetters}, body)=> {
		const axios = require('axios')
		axios.defaults.headers.common['Authorization'] = rootState.auth.token
		console.log(rootGetters.jwtSubject)
		commit("UPDATE_MESSAGE","")


		return axios.post(state.testuserApiUrl, body)
			.then(async (result) => {
				console.log(result.data)

				const statusCode = result.status ?? 500
				if(statusCode >= 200 && statusCode <= 299) {
					var createdUsers = markSisAndUpsUsers(
						result.data.ldap.map((testuserLdap) => {
							return { ldap: testuserLdap }
						})
					)

					createdUsers = await Promise.all(createdUsers.map((testuser) => {
						if (testuser.isUps) {
							return axios.get(state.testuserApiUrl + "/" + testuser.ldap.uid + "/ups")
								.then((result) => {
									return {...testuser, ups: result.data.ups?.[0] ?? {}}
								})
								.catch((error) => {
									console.log(error)

									commit("UPDATE_MESSAGE","Unable to retrieve UPS data for some testusers!")
									return Promise.resolve(testuser)
								})
						} else {
							return testuser
						}
					})).then((result) => (result))

					commit(CREATE_TEST_USER, createdUsers)
				
				} else if(statusCode >= 400 && statusCode <= 499) {
					commit("UPDATE_MESSAGE","There was an error creating your test user. You do not have the requisite permissions.")
					console.log(result.data)
				} else if(statusCode >= 500 && statusCode <= 599) {
					commit("UPDATE_MESSAGE","There was a server error creating your test user. Dev IDM Registry or Dev SIS might be down.")	
					console.log(result.data)
				}
			})
			.catch((error) => {
				commit("UPDATE_MESSAGE",`There was a error while creating your test user. Please try again later.
					${error.response.data.message}`)
				console.log(error)
				return Promise.reject(error)
			})
	},

	[UPDATE_TEST_USER]: ({commit,state,rootState,rootGetters}, payload)=> {
		const axios = require('axios')
		axios.defaults.headers.common['Authorization'] = rootState.auth.token
		commit(UPDATE_MESSAGE,"")
		
		return axios.put(state.testuserApiUrl + "/" + payload.editUid, payload.editAttributes)
			.then(async (result) => {
				console.log(result.data)

				const statusCode = result.status ?? 500
				if(statusCode >= 200 && statusCode <= 299) {
					var updateResult = result.data

					if (updateResult.hasOwnProperty("ups")) {
						updateResult.ups = await Promise.resolve(axios.get(state.testuserApiUrl + "/" + payload.editUid + "/ups")
							.then((result) => {
								return result.data.ups?.[0] ?? {}
							})
							.catch((error) => {
								console.log(error)

								commit("UPDATE_MESSAGE","Unable to retrieve UPS data for some testusers!")
								return Promise.resolve({})
							})
						).then((result) => (result))
					}

					console.log(updateResult)
					console.log(payload.editUid)
					commit(UPDATE_TEST_USER, {editResult: updateResult, editUid: payload.editUid})

				} else if(statusCode >= 400 && statusCode <= 499) {
					commit("UPDATE_MESSAGE","There was an error updating your test user. You do not have the requisite permissions.")
					console.log(result.data)
				} else if(statusCode >= 500 && statusCode <= 599) {
					commit("UPDATE_MESSAGE","There was a server error updating your test user. Dev IDM Registry or Dev SIS might be down.")	
					console.log(result.data)
				}
			})
			.catch((error) => {
				console.log("Update catch")
				console.log(error)
				commit("UPDATE_MESSAGE", `There was an error updating your test user(s). Please try again later.
					${error.response.data.message}`)
				return Promise.reject(error)
			})
	},

	[DELETE_TEST_USER]: ({commit,rootState}, ldapTestuser) => {
		const axios = require('axios')
		axios.defaults.headers.common['Authorization'] = rootState.auth.token
		commit(UPDATE_MESSAGE,"")


		return axios.delete(state.testuserApiUrl + "/" + ldapTestuser.ldap.uid,
			{ 
				headers: {
					Authorization: rootState.auth.token
				},
			})
			.then((result) => {
				console.log(result.data)
				const dn = result.data?.dn ?? ""
				const deletedUser = {uid: dn.substring(4, dn.indexOf(','))}


				commit(DELETE_TEST_USER, deletedUser)

			})
			.catch((error) => {
				console.log("Delete catch")
				console.log(error)
				commit("UPDATE_MESSAGE","There was an error deleting your test user(s). You do not have the requisite permissions.")
				return Promise.reject(error)
			})
	}


}


export default {
	state,
	getters,
	actions,
	mutations,
}